window.addEventListener("load", () => {
    function lineAnim(el) {
        el.classList.add('pdp-metric__grid-item-line--active');
    }

    const targetElement = document.querySelector('.pdp-metric')

    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
    };

    // Callback function to be executed when the element's visibility changes
    function handleIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                //console.log('Element is in the viewport');
                // Do something when the element enters the viewport
                document.querySelectorAll('.js-percent').forEach(item => {
                    let end = item.dataset.percent * 1;
                    counter(item, 0, end, 2000);
                    observer.disconnect();
                })
            } else {
                //console.log('Element is out of the viewport');
                // Do something when the element exits the viewport
            }
        });
    }

    // Create the Intersection Observer instance
    const observer = new IntersectionObserver(handleIntersection, options);

    // Start observing the target element
    observer.observe(targetElement);
}, false);